import { render } from "./ContactDetail.vue?vue&type=template&id=14884503"
import script from "./ContactDetail.vue?vue&type=script&lang=js"
export * from "./ContactDetail.vue?vue&type=script&lang=js"

import "./ContactDetail.vue?vue&type=style&index=0&id=14884503&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__